import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { getTopNewsList } from "../../../../services/apiMypageTop";

const Top = () => {
  // お知らせ一覧データ + 未読数データ
  const [Data, setData] = useState([]);

  // 初期表示時
  useEffect(() => {
    (async function () {
      const data = await getTopNewsList();
      if (data == undefined || !data) return;
      setData(data);
    })();
  }, []);

  const not_read_cnt = Data.not_read_cnt;
  const notice_list = Data.notice_list;

  return (
    <div>
      <div className="p-top-menu">
        <div className="container">
          <h1 className="p-top-ttl">渋谷ハチコウ大学マイページ</h1>
          <ul className="p-top-menu__list">
            <li className="p-top-menu__item">
              <Link className="p-top-menu__btn notice" to="/mypage/news/2">
                <span>あなたへのお知らせ</span>
                {not_read_cnt > 0 ? (
                  <span className="p-notif">{not_read_cnt}</span>
                ) : (
                  <></>
                )}
              </Link>
            </li>
            <li className="p-top-menu__item">
              <Link
                className="p-top-menu__btn search"
                to="/mypage/course/search/accepting"
              >
                <span>講座検索</span>
              </Link>
            </li>
            <li className="p-top-menu__item">
              <Link
                className="p-top-menu__btn course"
                to="/mypage/course/applied"
              >
                <span>申込状況・受講履歴</span>
              </Link>
            </li>
            <li className="p-top-menu__item">
              <Link className="p-top-menu__btn setting" to="/mypage/user/">
                <span>ユーザー情報の確認・変更</span>
              </Link>
            </li>
          </ul>
          <p className="p-top-link01">
            <a
              href={process.env.REACT_APP_SHIBUKATSU_WEB_DOMAIN + "/jukou/"}
              target="_blank"
              rel="noopener noreferrer"
            >
              <span>受講にあたって（新しいウィンドウで開きます）</span>
            </a>
          </p>
        </div>
      </div>
      <div className="p-news">
        <div className="container">
          <h2 className="p-news__ttl">お知らせ</h2>
          <ul className="p-news__list">
            <>
              {notice_list ? (
                notice_list.map((rData) => {
                  return (
                    <li className="p-news__item" key={rData.id}>
                      <Link
                        className="p-news__link"
                        to={"/mypage/news/detail/" + rData.id}
                      >
                        <p className="p-news__date">{rData.date}</p>
                        <span className="p-news__page-ttl">{rData.title}</span>
                      </Link>
                    </li>
                  );
                })
              ) : (
                <></>
              )}
            </>
          </ul>
          <p className="p-news__more">
            <Link className="p-news__more-link" to="/mypage/news/1">
              お知らせ一覧を見る
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};
export default Top;
